module.exports = __webpack_public_path__ + "static/media/logo-white.38c6e3f8.png";